module.exports = __webpack_public_path__ + "img/完善信息提示.5a907bae.png";